import { render, staticRenderFns } from "./userPaymentPpenetrationRate.vue?vue&type=template&id=11048f89&scoped=true&"
import script from "./userPaymentPpenetrationRate.vue?vue&type=script&lang=js&"
export * from "./userPaymentPpenetrationRate.vue?vue&type=script&lang=js&"
import style0 from "./userPaymentPpenetrationRate.vue?vue&type=style&index=0&id=11048f89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11048f89",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11048f89')) {
      api.createRecord('11048f89', component.options)
    } else {
      api.reload('11048f89', component.options)
    }
    module.hot.accept("./userPaymentPpenetrationRate.vue?vue&type=template&id=11048f89&scoped=true&", function () {
      api.rerender('11048f89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/userPaymentPpenetrationRate.vue"
export default component.exports